// extracted by mini-css-extract-plugin
export var copyableField = "_r6-4";
export var customerBadge = "_r6-0";
export var customerInfoTitle = "_r6-2";
export var details = "_r6-1";
export var dropdownContainer = "_r6-5";
export var dropdownImage = "_r6-6";
export var editAssigneeForm = "_r6-a";
export var editButton = "_r6-3";
export var email = "_r6-7";
export var hidden = "_r6-d";
export var input = "_r6-8";
export var saveButton = "_r6-b";
export var shopifyIcon = "_r6-c";
export var suggestionBadge = "_r6-e";
export var suggestionText = "_r6-f";
export var username = "_r6-9";